import { render, staticRenderFns } from "./SimpleFormEditorDialog.vue?vue&type=template&id=5ae2aa84&scoped=true"
import script from "./SimpleFormEditorDialog.vue?vue&type=script&lang=js"
export * from "./SimpleFormEditorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae2aa84",
  null
  
)

export default component.exports